export const getResponseList = (response: any) => (
    Array.isArray(response?.data?.data) ? response.data.data : []
);

export const getApiErrorMessage = (error: any, fallback: string) => (
    error?.response?.data?.message || error?.message || fallback
);

export const extractUploadedUrl = (rawResponse: any, preferObjectValue = false) => {
    const parsed = typeof rawResponse === 'string' ? JSON.parse(rawResponse) : rawResponse;

    if (preferObjectValue) {
        const dataValues = Object.values(parsed?.data || {});
        return dataValues.length > 0 ? String(dataValues[0]) : '';
    }

    if (Array.isArray(parsed?.data) && parsed.data.length > 0) {
        return parsed.data[0];
    }

    if (typeof parsed?.data === 'string') {
        return parsed.data;
    }

    const dataValues = Object.values(parsed?.data || {});
    return dataValues.length > 0 ? String(dataValues[0]) : '';
};

export const extractGeneratedDescription = (response: any) => {
    const data = response?.data?.data;

    if (typeof data === 'string') {
        return data;
    }

    if (Array.isArray(data?.hashtags)) {
        return data.hashtags.join(' ');
    }

    return data?.Description
        || data?.description
        || data?.message
        || data?.improved_text
        || data?.profile_description
        || data?.content
        || data?.text
        || response?.data?.message
        || '';
};
